<template>
  <div v-if="isOnPage">
    <div class="SearchBox SearchBox--onPage u-inlineBlock u-push">
      <form :action="searchAction" method="GET" class="SearchBox-form u-inlineBlock" @submit.prevent="submitSearch">
        <div class="Form-input Form-input--hollow Form-input--search">
          <input class="Form-inputEl SearchBox-input" name="query" placeholder="Search" type="text" v-model="query" />
          <a class="Form-inputSuffix Form-inputSuffix--icon" href="#" @click.prevent="submitSearch">
            <symbol-icon icon-name="uiSearch" classes="Icon--colorRed Icon--sizeSmallest" />
          </a>
        </div>
      </form>
    </div>
    <combo-button class="u-inlineBlock" :is-small="true" :combos="searchSegments" :selected-combo="selectedSegment" @combo-selected="segmentSelected" />
  </div>

  <!--
  <div class="search">
      <div class="search-form">
          <form action="https://cottonbureau.com/search" method="GET">
              <input name="query" placeholder="Search" type="text">
              <a href="#" class="search-form-button">
                  @include('icons/arrow-stroke', array('classes' => 'icon'))
              </a>
              <div class="search-form-icon">
                  @include('icons/search-stroke', array('classes' => 'icon'))
              </div>
          </form>
      </div>
  </div>
  -->

  <div v-else>
    <div v-if="mobileBreakpoint" class="search">
      <button class="search-toggle" @click.prevent="toggleSearch">
        <symbol-icon icon-name="search-stroke" classes="icon" />
      </button>
      <transition @enter="enter" @leave="leave" @css="false">
        <div class="mobile-search-field" v-show="showSearch">
          <form :action="searchAction" method="GET" class="" @submit.prevent="submitSearch">
            <input class="" name="query" placeholder="Search" type="text" v-model="query" ref="searchInput" />
            <a class="search-form-button" href="#" @click.prevent="submitSearch">
              <symbol-icon icon-name="arrow-stroke" classes="icon" />
            </a>
          </form>
        </div>
      </transition>
    </div>

    <div v-else class="search">
      <div class="search-form">
        <form :action="searchAction" method="GET" class="" @submit.prevent="submitSearch" ref="searchForm">
          <div class="Form-input">
            <input class="" name="query" placeholder="Search" type="text" v-model="query" @focus="expandSearch" />
            <a class="search-form-button" href="#" @click.prevent="submitSearch">
              <symbol-icon icon-name="arrow-stroke" classes="icon" />
            </a>
            <div class="search-form-icon">
              <symbol-icon icon-name="search-stroke" classes="icon" />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import Velocity from "velocity-animate";
import { defineAsyncComponent } from "vue";
const ComboButton = defineAsyncComponent(() => import("@/components/combo-button.vue"));
const SymbolIcon = defineAsyncComponent(() => import("@/components/symbol-icon.vue"));

const SEARCH_SEGMENTS = [
  {
    id: "products",
    text: "Designs",
  },
  {
    id: "users",
    text: "People",
  },
  {
    id: "tags",
    text: "Tags",
  },
];
const SEARCH_ACTION = SITE_URL + "search";

export default {
  components: {
    ComboButton,
    SymbolIcon,
  },

  computed: {
    mobileBreakpoint() {
      return !this.isDesktopBreakpoint;
    },
  },

  data() {
    let selectedSegment = SEARCH_SEGMENTS.find((segment) => segment.id === this.currentSegment);

    return {
      query: this.currentQuery,
      searchAction: SEARCH_ACTION,
      searchSegments: SEARCH_SEGMENTS,
      segment: this.currentSegment,
      selectedSegment: selectedSegment,
      showSearch: false,
    };
  },

  methods: {
    collapseSearch() {
      //this.$refs.searchForm.classList.remove('SearchBox-form--wide');
    },

    enter(el, done) {
      Velocity(el, "slideDown", {
        complete: () => {
          this.$emit("toggle-search", this.showSearch);

          this.$refs.searchInput.focus();

          done();
        },
      });
    },

    expandSearch() {
      //this.$refs.searchForm.classList.add('SearchBox-form--wide');
    },

    leave(el, done) {
      Velocity(el, "slideUp", {
        complete: () => {
          this.$emit("toggle-search", this.showSearch);

          done();
        },
      });
    },

    segmentSelected(segment) {
      this.segment = segment.id;

      this.submitSearch();
    },

    submitSearch() {
      let searchTerms = "";

      // if (this.segment) {
      //   path += encodeURIComponent( this.segment ) + '/';
      // }

      searchTerms += encodeURIComponent(this.query);

      window.location.href = this.searchAction + "?query=" + searchTerms;
    },

    toggleSearch() {
      this.showSearch = !this.showSearch;
    },
  },

  props: {
    isOnPage: {
      type: Boolean,
      default: false,
    },

    currentQuery: {
      type: String,
      default: "",
    },

    currentSegment: {
      type: String,
      default: "",
    },

    isDesktopBreakpoint: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
